import { useTrackedQuery } from "@/hooks/useTrackedQuery";
import { supabase } from "@/lib/supabase";
import { PurchasingNote } from "./PurchasingNoteCell";
import { getPurchasingNoteQueryKey } from "./purchasing-note-query-key";

export type PurchasingNotesByItemId = Map<number, PurchasingNote>;

export function usePurchasingNotesByItemId(jobId: number | null) {
  return useTrackedQuery<PurchasingNotesByItemId>({
    queryKey: getPurchasingNoteQueryKey(jobId),
    queryFn: async () => {
      const { data } = await supabase.from("PurchasingNote").select("*").eq("jobId", jobId!).throwOnError();
      return new Map(data.map((note) => [note.itemId, note]));
    },
    enabled: jobId !== null,
    staleTime: 30 * 60 * 1000, // 30 minutes - cache data for this duration before considering it stale
    gcTime: 35 * 60 * 1000, // 35 minutes - keep unused data in cache slightly longer than staleTime
  });
}
